import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

export const UserLogoComponentName = 'UserLogo' as const;
export const UserLogoParts = ['container', 'image'] as const;

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(UserLogoParts);

const baseStyle = definePartsStyle({
  container: {
    padding: 1,
    backgroundColor: 'neutral.100',
    borderRadius: 'default',
    width: 'full',
  },
  image: {
    objectFit: 'contain',
    boxSize: 'full',
    maxHeight: '200px',
  },
});

export const UserLogoStyle = defineMultiStyleConfig({ baseStyle });
